import { render } from "./CoursesSidebar.vue?vue&type=template&id=046b1f5f"
import script from "./CoursesSidebar.vue?vue&type=script&lang=js"
export * from "./CoursesSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__